var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62575 28.6624C5.45825 29.6126 3.5 30.9251 3.5 32.375C3.5 35.2747 11.3348 37.625 21 37.625C30.6652 37.625 38.5 35.2747 38.5 32.375C38.5 30.9251 36.5409 29.6126 33.3742 28.6624",
    stroke: "#45894D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30.625C21 30.625 32.375 23.191 32.375 14.5967C32.375 8.46825 27.2825 3.5 21 3.5C14.7175 3.5 9.625 8.46825 9.625 14.5967C9.625 23.191 21 30.625 21 30.625Z",
    stroke: "#45894D",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.25C22.1603 19.25 23.2731 18.7891 24.0936 17.9686C24.9141 17.1481 25.375 16.0353 25.375 14.875C25.375 13.7147 24.9141 12.6019 24.0936 11.7814C23.2731 10.9609 22.1603 10.5 21 10.5C19.8397 10.5 18.7269 10.9609 17.9064 11.7814C17.0859 12.6019 16.625 13.7147 16.625 14.875C16.625 16.0353 17.0859 17.1481 17.9064 17.9686C18.7269 18.7891 19.8397 19.25 21 19.25Z",
    stroke: "#45894D",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.97d82766b55b8215ef4fa2242382c356.svg";
export { ForwardRef as ReactComponent };